import { register } from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.mjs';

const initSingleSwiper = (swiperEl) => {
  try {
    const dataParams = swiperEl.getAttribute("data-init-params");
    const swiperParams = JSON.parse(dataParams);

    if (swiperEl.initialized) {
      swiperEl.initialized = false;
    }

    Object.assign(swiperEl, swiperParams);
    swiperEl.initialize();
  } catch (error) {
    console.error("Error initializing swiper:", error);
  }
};

const initSwipers = () => {
  const preInitSwipers = document.querySelectorAll(
    "swiper-container[init='false']"
  );

  if (!preInitSwipers.length) return;
  preInitSwipers.forEach(initSingleSwiper);
};

const afterSwiperInit = () => {
  customElements.whenDefined('swiper-container').then(() => {
    document.querySelectorAll('swiper-container').forEach((el) => el.classList.add('is-initialized'));
  });
};

window.addEventListener("load", () => {
  register();
  initSwipers();
  afterSwiperInit();
});
